export default __webpack_public_path__ + "static/media/feature-3.f60861e5.svg";